import EE from 'eventemitter3'

const ee = new EE()

export default ee

export const ON_DIALOG_REMOVE = 'ON_DIALOG_REMOVE'
export const HEADER_THEME_CHANGED = 'HEADER_THEME_CHANGED'
